var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.DataHeader.status === '10') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cekkirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                Kirim")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                  Lampiran Dokumen / Data\n                  "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "title": "Tambah Dokumen/Data Pelengkap",
      "type": "button"
    },
    on: {
      "click": _vm.addModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Dokap")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editDokap(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), (dokap.kd_dokap === 151) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.kd_dokap === 145 || dokap.kd_dokap === 146) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuanftz'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v("\n              Back")])], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Tambah Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDokap = false
      }
    },
    model: {
      value: (_vm.ModalDokap),
      callback: function($$v) {
        _vm.ModalDokap = $$v
      },
      expression: "ModalDokap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.jndok),
      expression: "isidokap.jndok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Jenis Dokumen/Data Pelengkap"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen/Data")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.negara),
      expression: "isidokap.negara"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    attrs: {
      "title": "Pilih Data Pelengkap",
      "lass": "form-control"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Data")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: "isidokap.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.isidokap.isian1),
      callback: function($$v) {
        _vm.isidokap.isian1 = $$v
      },
      expression: "isidokap.isian1"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: "errors.has('This')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: "isidokap.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: "errors.has('Isi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: "isidokap.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: "errors.has('Tanggal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: "'required|field'"
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: "edit.akhirberlaku"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Akhir Berlaku')),
      expression: "errors.has('Akhir Berlaku')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Akhir Berlaku')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.keterangan),
      expression: "isidokap.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Terkait Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.Modaledit = false
      }
    },
    model: {
      value: (_vm.Modaledit),
      callback: function($$v) {
        _vm.Modaledit = $$v
      },
      expression: "Modaledit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Edit Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.jndok),
      expression: "edit.jndok"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen/Data",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.negara),
      expression: "edit.negara"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Kode Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.edit.keterangan = jn.nm_lokasi
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: "edit.isian1"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxchar1,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: "edit.isian1"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: "errors.has('This')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi2
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: "edit.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxchar2,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: "errors.has('Isi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: "edit.isian2"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: "errors.has('Tanggal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: "edit.akhirberlaku"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.keterangan),
      expression: "edit.keterangan"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "title": "Upload Dokumen",
      "label": "Upload File (Max. 700 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "title": "Upload Dokumen",
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "medium"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: "Modaleditdtl"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Peti Kemas"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: "nocont"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "11",
      "title": "Nomor Peti Kemas",
      "name": "petikemas"
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petikemas')),
      expression: "errors.has('petikemas')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            Nomor Peti Kemas wajib diisi\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        numeric: true
      }),
      expression: "{ required: true, numeric: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: "ukcont"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "title": "Nomor Peti Kemas",
      "name": "ukuran"
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ukuran')),
      expression: "errors.has('ukuran')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            Wajib diisi dan berisi angka\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "<br>"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n            Tambah")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.hapusrow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.Modaleditdtl = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v("  \n      "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.savedokapdtl
    }
  }, [_vm._v("Simpan")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl1 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl1),
      callback: function($$v) {
        _vm.Modaleditdtl1 = $$v
      },
      expression: "Modaleditdtl1"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: "nocont"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor",
      "name": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: "ukcont"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "title": "Nomor Peti Kemas",
      "name": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah Dokumen",
      "type": "button"
    },
    on: {
      "click": _vm.savedokapdtl1
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Dokumen")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [(peti.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + peti.url_file + '/' + peti.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmdtl(peti.id_permohonan_dokap_dtl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDisclaimer = false
      }
    },
    model: {
      value: (_vm.ModalDisclaimer),
      callback: function($$v) {
        _vm.ModalDisclaimer = $$v
      },
      expression: "ModalDisclaimer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('b-form-checkbox', {
    attrs: {
      "value": "Y",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: "disclaimer"
    }
  }, [_vm._v("\n            Saya menyatakan bahwa data yang disampaikan adalah benar\n            dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan\n          ")]), _vm._v(" "), (_vm.disclaimer === 'Y') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])]) : _vm._e()], 1)], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7e7ad4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pengajuan/DetilHeaderFtz.vue
// module id = 314
// module chunks = 0